var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgColumnsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 2.25H8C4.83 2.25 2.25 4.83 2.25 8V16C2.25 19.17 4.83 21.75 8 21.75H16C19.17 21.75 21.75 19.17 21.75 16V8C21.75 4.83 19.17 2.25 16 2.25ZM20.25 16C20.25 18.34 18.34 20.25 16 20.25H8C5.66 20.25 3.75 18.34 3.75 16V8C3.75 5.66 5.66 3.75 8 3.75H16C18.34 3.75 20.25 5.66 20.25 8V16Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 7.25C11.59 7.25 11.25 7.59 11.25 8V16C11.25 16.41 11.59 16.75 12 16.75C12.41 16.75 12.75 16.41 12.75 16V8C12.75 7.59 12.41 7.25 12 7.25Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 7.25C15.59 7.25 15.25 7.59 15.25 8V16C15.25 16.41 15.59 16.75 16 16.75C16.41 16.75 16.75 16.41 16.75 16V8C16.75 7.59 16.41 7.25 16 7.25Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 7.25C7.59 7.25 7.25 7.59 7.25 8V16C7.25 16.41 7.59 16.75 8 16.75C8.41 16.75 8.75 16.41 8.75 16V8C8.75 7.59 8.41 7.25 8 7.25Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColumnsIcon);
export default __webpack_public_path__ + "static/media/columns_icon.e2ba6dd3404be8fc93cfb61250ce2f99.svg";
export { ForwardRef as ReactComponent };